import {
    Badge,
    Box,
    Flex,
    Group,
    Progress,
    Stack,
    Text,
    Tooltip,
} from '@mantine/core';
import {
    CONVERSATION_STATUSES,
    CONVERSATION_TYPES,
} from '../../../../common/enums/enums';
import { getEnumColor, getEnumLabel } from '../../../../../utils/enumUtils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';

const AgentStatusProgress = ({ name, status }) => {
    const statusLookup = {
        Running: 'teal.6',
        Pending: 'blue',
        Disconnected: 'red',
        default: 'gray',
    };
    const progressColor = statusLookup[status] || statusLookup['default'];
    return (
        <Tooltip
            label={
                <Group gap={2}>
                    <Text size={'sm'}>{name}</Text>
                    <Badge
                        size={'xs'}
                        color={progressColor}>
                        {status}
                    </Badge>
                </Group>
            }>
            <Progress
                size='xs'
                color={progressColor}
                value={100}
                transitionDuration={0}
            />
        </Tooltip>
    );
};

const test_agents = [
    { name: 'agent-01', status: 'Running' },
    { name: 'agent-01', status: 'Running' },
    { name: 'agent-02', status: 'Running' },
    { name: 'agent-03', status: 'Running' },
    { name: 'agent-04', status: 'Pending' },
    { name: 'agent-05', status: 'Unknown' },
    { name: 'agent-06', status: 'Disconnected' },
];

const StatusCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const thresholds = {
        'teal.6': 70,
        'blue': 35,
        'red': 0,
    };

    const value = 75;
    const indexColor = Object.keys(thresholds).find((x) => {
        const thresholdValue = thresholds[x];
        return value >= thresholdValue;
    });

    const badgeColor = getEnumColor(CONVERSATION_STATUSES, rowData.status);
    const badgeLabel = getEnumLabel(CONVERSATION_STATUSES, rowData.status);

    return (
        <Group gap={'xs'}>
            <Stack
                gap={4}
                miw={100}>
                <Group
                    align={'center'}
                    justify='center'
                    gap={'xs'}>
                    <Badge
                        color={badgeColor}
                        size={'sm'}
                        py={0}>
                        {badgeLabel}
                    </Badge>
                </Group>
            </Stack>
        </Group>
    );
};

const StatusColumn = () => ({
    id: 'status',
    accessorKey: 'status',
    header: 'Status',
    minSize: 40,
    maxSize: 60,
    Cell: ({ cell }) => <StatusCell cell={cell} />,
});
export default StatusColumn;
